export default [
  {
    text: "Home",
    path: "/home",
    icon: "home"
  },
  {
    text: "HAProxy",
    icon: "globe",
    items: [
      { text: 'Validation', path: '/haproxy-config-validate' },
      { text: 'Configuration', path: '/haproxy-config' },
      { text: "SSL Certs", path: "/haproxy-certs" }
    ]
  },
  {
    text: "Nginx",
    icon: "box",
    items: [
      { text: 'Sites', path: '/nginx-sites' }
    ]
  },
  {
    text: "Docker",
    icon: "product",
    items: [
      { text: "All Containers", path: "/docker-all-containers" },
      { text: "Stats", path: "/docker-stats" },
      { text: "Networks", path: "/docker-networks" },
      { text: "Cont. + Net", path: "/docker-containers-with-networks" },
      { text: "Net + Cont.", path: "/docker-networks-with-containers" }
    ]
  },
  {
    text: "WordPress",
    icon: "ordersbox",
    items: [
      { text: "Site Snapshots", path: "/wordpress-site-snapshots" }
    ]
  },
  {
    text: "Cloudflare",
    icon: "link",
    items: [
      { text: "DNS Records", path: "/cloudflare-dns-records" },
      { text: "DNS Zones", path: "/cloudflare-dns-zones" },
      { text: "All Records", path: "/cloudflare-dns-records-all" }
    ]
  }
]
